/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据巡演Id查询巡演站点列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  tourId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.TourProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/tour/${tourId}/products`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
